import React from 'react';
import { Image, Text } from '@ui/atoms';
import { ArrowRightIcon } from '@heroicons/react/outline';

const TabContent = ({ content, label = null, id, showInsightsAsList = true, showOnCategoryPage = false, headingClass = null }) => {
    const renderInsights = () => {
        if (Array.isArray(content.insights)) {
            return <>
                {showOnCategoryPage && content.description ? <p className="text-basicWhite w-full xl:text-primary-100 p5-regular xl:p3-regular xl:mt-2">
                    {content.description}
                </p> : null}
                {content.insights.map((insight, index) => showInsightsAsList ? (
                    <ul key={index} className={`flex w-full flex-col gap-4 xl:gap-0 list-none xl:list-disc xl:ml-6 text-basicWhite my-3`}>
                        <li className="h7-semibold xl:h6-semibold bg-basicWhite/10 xl:bg-transparent py-2 xl:py-0 px-4 xl:px-0 rounded-lg">{insight.title}</li>
                        <li className="h7-semibold xl:p4-regular bg-basicWhite/10 xl:bg-transparent py-2 xl:py-0 px-4 xl:px-0 rounded-lg xl:block hidden">{insight.description}</li>
                    </ul>
                ) : (
                    <div className='h6-semibold my-2 w-max text-basicWhite py-2 px-4 rounded-lg bg-bond-analyser-category-page-tags-bg'>{insight?.title}</div>
                ))}
            </>
        }
        return (
            <>
                <span className="italic text-basicWhite xl:text-primary-100 p5-regular xl:p3-regular">
                    {content.insights}
                </span>
                <p className="text-basicWhite xl:text-primary-100 p5-regular xl:p3-regular xl:mt-2">
                    {content.description}
                </p>
            </>
        );
    };

    return (
        <div className={`grid ${showOnCategoryPage ? 'grid-cols-6' : 'grid-cols-5'} grid-cols-5 gap-8 xl:gap-6 bg-[rgba(214,228,240,0.04)] bond-analyser-homepage-tab-section xl:rounded-2xl pt-6 pb-8 px-4 xl:p-8 xl:mt-12 xl:border xl:border-basicWhite/20 hover:border-primary-100`}>
            <div className={`flex col-span-full ${showOnCategoryPage ? 'xl:col-span-4' : 'xl:col-span-3'} xl:col-span-3 flex-col justify-between`}>
                <div>
                    {label ? <Text
                        content={label}
                        className="h4-semibold xl:hidden mb-4 text-basicWhite"
                    /> : null}
                    <div className='flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-4'>
                        {id ? 
                            <Text
                                content={`0${id}`}
                                className='h4-semibold xl:h2-semibold text-basicWhite/20 xl:mb-4'
                            /> 
                        : null}
                        <Text
                            content={content.heading}
                            isInnerHtml
                            className={`${headingClass || 'h6-semibold xl:h3-semibold' } text-basicWhite mb-2 xl:mb-4`}
                        />
                    </div>
                    <div className={`mb-8 ${!showInsightsAsList ? 'flex items-center gap-y-2 gap-x-2 flex-wrap' : ''}`}>
                        {renderInsights()}
                    </div>
                </div>
                <button className="mt-auto flex items-center gap-2 px-5 py-2 rounded-full border border-secondary-300 text-basicWhite hover:bg-primary-800 transition-all p4-medium w-fit">
                    Explore in depth
                    <ArrowRightIcon className='w-4'/>
                </button>
            </div>
            <div className={`w-full h-full col-span-full xl:col-span-2 flex justify-start xl:justify-end items-center`}>
                <Image
                    src={content.image}
                    alt="Bond Market Growth Trends"
                    className={showOnCategoryPage ? "xl:max-w-[320px] w-full" : "w-full h-full"}
                />
            </div>
        </div>
    );
};

export default TabContent; 